<template>
  <v-container class="content">
    <!--loading screen when add video request is being handled-->
    <LoadingScreen :loading="loading" />

    <div class="nav" @click="goBack">
      <v-icon size="12px" color="#00457C">arrow_back_ios</v-icon> Back
    </div>
    <div class="header text-left">Add News and Events Item</div>
    <v-row class="cover-photo">
      <v-col cols="12">
        <label for="cover-photo">Cover Photo</label>
      </v-col>
      <v-col cols="6" md="3">
        <input
          id="cover-photo"
          type="file"
          accept="image/x-png, image/jpeg"
          @change="(e) => setImage(e.target.files[0])"
        />
        <input type="text" readonly v-model="imageFileName" />
      </v-col>
      <v-col cols="6" md="3">
        <label for="cover-photo" id="browse-btn">Browse</label>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <label for="title">Title</label>
        <input
          id="title"
          type="text"
          v-model="title"
          @input="$v.title.$touch()"
        />
        <div class="error-msg" v-show="$v.title.$invalid && $v.title.$dirty">
          This is a required field.
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12">
        <label for="content">Content</label>
        <textarea
          id="content"
          type="text"
          v-model="content"
          @input="$v.content.$touch()"
        />
        <div
          class="error-msg"
          v-show="$v.content.$invalid && $v.content.$dirty"
        >
          This is a required field.
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <label for="URL">URL</label>
        <input id="URL" type="text" v-model="url" @input="$v.url.$touch()" />
        <div class="error-msg" v-show="$v.url.$invalid && $v.url.$dirty">
          Please enter a URL in the following format: http://www.example.com/.
        </div>
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="12" md="3">
        <label for="sequence">Sequence</label>
        <input
          id="sequence"
          type="text"
          v-model="sequence"
          @input="$v.sequence.$touch()"
        />
      </v-col>
    </v-row>
    <v-row>
      <v-col cols="6" md="3">
        <v-btn
          color="#00457C"
          :disabled="$v.$invalid"
          @click="submitNewsEventsForm"
          >Submit</v-btn
        >
      </v-col>
      <v-col cols="4" md="3">
        <v-btn color="#00457C" :disabled="$v.$invalid" @click="preview"
          >Preview</v-btn
        >
      </v-col>
    </v-row>
    <v-row v-if="success">
      <v-col cols="12">
        <v-alert type="success"
          >News and events item added successfully.</v-alert
        >
      </v-col>
    </v-row>
    <v-row v-if="error">
      <v-col cols="12">
        <v-alert type="error">Error occurred. Please try again.</v-alert>
      </v-col>
    </v-row>

    <!--popup when user clicks on view-->

    <v-dialog
      v-if="newsEventsPreview"
      v-model="newsEventsPreview"
      max-width="450px"
      overlay-opacity="0"
    >
      <v-card
        class="news-card"
        @click="newsEventsRedirect(newsEventsPreviewDetails.url)"
        :style="{
          backgroundImage: 'url(' + newsEventsPreviewDetails.imageUrl + ')',
        }"
      >
        <div class="title">{{ newsEventsPreviewDetails.title }}</div>
        <div class="desc">{{ newsEventsPreviewDetails.desc }}</div>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import axios from "axios";
import { required, url } from "vuelidate/lib/validators";
import LoadingScreen from "./commons/LoadingScreen";

export default {
  components: {
    LoadingScreen,
  },

  data() {
    return {
      newsEventsPreview: false,
      newsEventsPreviewDetails: null,
      title: "",
      content: "",
      url: "",
      imageFile: null,
      imageUrl: null,
      imageFileName: null,
      loading: false,
      success: false,
      error: false,
      sequence: null,
    };
  },

  //rules for validation
  validations: {
    title: {
      required,
    },
    content: {
      required,
    },
    url: {
      required,
      url,
    },
    imageFileName: {
      required,
    },
  },

  methods: {
    closeMsgDialog() {
      this.newsEventsPreview = false;
      this.newsEventsPreviewDetails = null;
    },
    preview() {
      this.newsEventsPreview = true;
      this.newsEventsPreviewDetails = {
        url: this.url,
        imageUrl: URL.createObjectURL(this.imageFile),
        title: this.title,
        desc: this.content,
      };
    },
    setImage(file) {
      if (file !== null) {
        // Set image file
        this.imageFile = file;
        this.imageFileName = file.name;
      }
    },

    submitNewsEventsForm() {
      this.loading = true;

      const newsEventsFormData = new FormData();
      newsEventsFormData.append("imageFile", this.imageFile);
      axios
        .post(
          process.env.VUE_APP_HOST_SERVER + "/api/image_upload/news-events",
          newsEventsFormData,
          {
            //merge database branch into master branch for maxicash-server
            headers: { "Content-Type": "multipart/form-data" },
          }
        )
        .then((res) => {
          console.log(
            "Successfully uploaded new events image ",
            res.data.imageUrl
          );

          this.imageUrl = res.data.imageUrl;
          const newsEventsDetails = {
            title: this.title,
            desc: this.content,
            url: this.url,
            imageUrl: this.imageUrl,
            sequence: this.sequence,
          };

          axios
            .post(
              process.env.VUE_APP_HOST_SERVER + "/api/news-events/add",
              newsEventsDetails
            )
            .then(() => {
              console.log("Successfully Created News & Events Item");
              this.loading = false;
              this.success = true;
              this.error = false;
            });
        })
        .catch((err) => {
          console.log(err);
          this.loading = false;
          this.error = true;
        });
    },

    goBack() {
      this.$router.push({ name: "HomepageNewsEvents" }).catch(() => {});
    },
  },
};
</script>

<style scoped>
.news-card {
  background-size: cover;
  background-position: center;
  box-shadow: inset 0 0 0 2000px rgba(0, 0, 0, 0.3);
  border-radius: 8px;
  padding: 25px;
  max-width: 100%;
  height: 140px;
  display: flex;
  flex-direction: column;
  justify-content: center;
}

.news-card .title {
  font-size: 16px !important;
  margin-bottom: 5px;
  color: white;
}

.news-card .desc {
  letter-spacing: -0.01px;
  font-size: 14px !important;
  color: white;
}

.content {
  box-shadow: 0px 1px 20px rgba(163, 163, 163, 0.25);
  border: 1px solid #eeeeee;
  padding: 25px;
  text-align: initial;
}

.content .row {
  padding-bottom: 18px;
}

.content .row:nth-last-child(1) {
  padding-bottom: 0;
}

.content .nav {
  color: #00457c;
  font-weight: bold;
  margin-bottom: 40px;
  font-size: 16px;
  cursor: pointer;
}

.content .header {
  font-size: 26px;
  margin-bottom: 20px;
  font-weight: normal;
}

.content button {
  width: 100%;
  font-size: 14px;
  font-weight: normal;
  color: white;
  text-transform: none;
  letter-spacing: normal;
}

label {
  font-size: 14px;
  color: #6f6f6f;
  margin-bottom: 10px;
  display: block;
}

.cover-photo div:first-child {
  padding-bottom: 0;
}

.cover-photo div:nth-child(2),
.cover-photo div:nth-child(3) {
  padding-top: 0;
}

#cover-photo {
  display: none;
}

label#browse-btn {
  display: inline-block;
  background: #ffffff;
  box-shadow: 0px 1px 5px rgba(120, 120, 120, 0.25);
  border-radius: 5px;
  color: #9b9b9b;
  padding: 10px;
  margin-bottom: 0;
}

input[type="text"] {
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
  width: 100%;
  font-size: 14px;
}

.error-msg {
  font-size: 10px;
  color: #ea6254;
  margin-top: 5px;
}

textarea {
  padding: 10px;
  box-sizing: border-box;
  border: 1px solid #dfdfdf;
  border-radius: 5px;
  width: 100%;
  font-size: 14px;
}
</style>
